import { FolderTagIcon } from '$components'
import { FormDatePicker, FormErrorMessage, FormFieldGroup, FormGroup, FormLabel, FormSelect, FormTextarea, Text } from '$components'
import { AvailableSlots } from './available-slots'
import { AppointmentMetadata } from './metadata'
import { ClientSection } from './client-section'
import { PetSection } from './pet-section'
import { useInfiniteServiceOptions } from '$hooks/use-infinite-service-options'
import { useFormContext } from 'react-hook-form'
import { CreateAppointmentSchema, Input } from '.'
import dayjs from 'dayjs'
import { PersonFilter } from './person-filter'
import { useState } from 'react'
import { useLocation } from 'react-router'
import { DatePickerTrigger } from './date-picker-trigger'

export function CreateAppointmentFormContent() {
  const { getValues, formState: { errors } } = useFormContext<CreateAppointmentSchema>()
  const { state } = useLocation()
  const [personIds, setPersonIds] = useState<number[]>(state?.slot?.groomerId ? [state.slot.groomerId] : [])
  const today = dayjs.utc()

  const serviceOptions = useInfiniteServiceOptions({
    filters: {
      pet_id: getValues(Input.Pet) ? Number(getValues(Input.Pet)?.id) : undefined,
    },
  })

  return (
    <div className="flex flex-col gap-stack-section h-full">
      <ClientSection />
      <PetSection />

      <FormGroup label="Service Information">
        <div className="space-y-stack-roomy">
          <FormFieldGroup>
            <FormLabel htmlFor={Input.Services}>
              Services
            </FormLabel>
            <FormSelect
              name={Input.Services}
              placeholder="Select the services"
              icon={FolderTagIcon}
              multiple
              {...serviceOptions}
            />
          </FormFieldGroup>

          <FormFieldGroup>
            <FormLabel htmlFor={Input.Date}>
              Date
            </FormLabel>
            <FormDatePicker
              name={Input.Date}
              min={today}
              trigger={() => <DatePickerTrigger personIds={personIds} />}
            />
          </FormFieldGroup>
        </div>
      </FormGroup>

      <AppointmentMetadata />

      <div className="flex flex-col">
        <div className="flex items-center justify-between gap-stack-tight mb-stack">
          <Text
            as="h2"
            type="s"
            className="text-nowrap"
          >
            Available Appointments
          </Text>

          <PersonFilter
            value={personIds}
            onChange={setPersonIds}
          />
        </div>

        <AvailableSlots personIds={personIds} />

        <FormErrorMessage
          error={errors[Input.Slot]?.message}
          className="mt-stack-tight"
        />
      </div>

      <FormGroup label="Additional Information">
        <FormFieldGroup>
          <FormLabel htmlFor={Input.Notes}>
            Internal Notes
          </FormLabel>

          <FormTextarea
            name={Input.Notes}
            placeholder="Your notes"
          />
        </FormFieldGroup>
      </FormGroup>
    </div>
  )
}
